import { finish, error } from '../../../modules/transactions/actions/unassign';
import api from '../../../api';

export function request(dispatch, { accountId, id }) {
    api.request('DELETE', '/transactions/' + accountId + '/' + id + '/assignee').then(
        (data) => dispatch(finish(id, data)),
        ({ errors }) => dispatch(error(id, errors))
    );
}
